module.exports = __webpack_public_path__ + "img/tip_icon.04ae6b27.png";